import { LifecyclePhase, type LifecycleHook } from '@tundr/lifecycle-hooks';
import {
  useGetLoggedHrPermission,
  usePermissionsStore,
} from '@tundr/permissions';

let cancelPolling: (() => void) | null = null;

export const permissionsFetchOp: LifecycleHook = {
  name: 'permissions:fetch',
  fn: async () => {
    cancelPolling?.();
    cancelPolling = null;
    const store = usePermissionsStore();
    store.clearOnLogout();
    const { runAsync, cancel } = useGetLoggedHrPermission({
      manual: true,
      onSuccess: (response) => {
        store.setPermissions(response.data.permissions);
        store.setRole(response.data.role ?? null);
      },
    });
    cancelPolling = cancel;
    await runAsync();
  },
  phases: [
    { phase: LifecyclePhase.SESSION_INIT, awaited: true, critical: false },
  ],
};

export const permissionsResetOp: LifecycleHook = {
  name: 'permissions:reset',
  fn: () => {
    cancelPolling?.();
    cancelPolling = null;
    usePermissionsStore().clearOnLogout();
  },
  phases: [{ phase: LifecyclePhase.LOGOUT }],
};
